import React, { Component } from 'react';
import styled from 'styled-components';
import './App.css';
import { Link } from 'react-router-dom'

const MainContent = styled.div`
  width: 94%;
  max-width: 800px;
  margin: 0 auto;
  padding: 16px 0;
`

const Card = styled.div`
  background: #fff;
  padding: 28px 20px;
  line-height: 1.6;
  font-size: 15px;
  @media (min-width: 700px) {
    padding: 30px 40px;
  }
`

const Point = styled.h2`
  display: block;
  margin: 0 auto 36px; 
  width: 200px;
  color: #444;
  background: linear-gradient(transparent 70%, #fbc78d 70%);
  text-align: center;
  font-size: 16px;
  font-weight: bold;
`

const PolicyTitle = styled.h4`
  font-weight: bold;
  margin-bottom: 6px;
`

const PolicyText = styled.p`
  margin-bottom: 18px;
`

const PolicyLink = styled.a`
  display: block;
  color: rgb(146, 132, 132);
`

const Footer = styled.footer`
  margin-top: 60px;
  background: #666;
  font-size: 12px;
  color: #fff;
  a {
    color: #fff;
  }
`

class PrivacyScreen extends Component {
  render() {
    return (
      <div>
        <MainContent>
          <Card style={{ marginBottom: '40px' }}>
            <Point>プライバシーポリシー</Point>
            <PolicyTitle>個人情報の利用目的</PolicyTitle>
            <PolicyText>
              当サイトでは、メールでのお問い合わせ、メールマガジンへの登録などの際に、名前（ハンドルネーム）、メールアドレス等の個人情報をご登録いただく場合がございます。<br />これらの個人情報は質問に対する回答や必要な情報を電子メールなどをでご連絡する場合に利用させていただくものであり、個人情報をご提供いただく際の目的以外では利用いたしません。
            </PolicyText>
            <PolicyTitle>個人情報の第三者への開示</PolicyTitle>
            <PolicyText>
              当サイトでは、個人情報は適切に管理し、「本人のご了解がある場合」・「法令等への協力のため、開示が必要となる場合」を除いて第三者に開示することはありません。
            </PolicyText>
            <PolicyTitle>個人情報の開示、訂正、追加、削除、利用停止</PolicyTitle>
            <PolicyText>
              本人からの個人データの開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させていただいた上、速やかに対応させていただきます。
            </PolicyText>
            <PolicyTitle>クッキー（Cookie）</PolicyTitle>
            <PolicyText>
              当サイトでは、一部のコンテンツについてCookie（クッキー）を利用しています。<br />Cookieとは、サイトにアクセスした際にブラウザに保存される情報ですが、お名前やメールアドレス等の個人情報は含まれません。<br />当サイトにアクセスいただいた方々に効果的な広告を配信するためやアクセス解析にCookieの情報を利用させていただく場合があります。<br />ブラウザの設定により、Cookieを使用しないようにすることも可能です。<br />当サイトで利用しているアクセス解析、広告サービスは以下のとおりです。
              <PolicyLink href="https://marketingplatform.google.com/about/" target="_blank">グーグルアナリティクス</PolicyLink>
              <PolicyLink href="https://www.google.com/intl/ja_jp/adsense/start/" target="_blank">Google AdSense</PolicyLink> 
            </PolicyText>
            <PolicyTitle>第三者配信の広告サービスとCookie</PolicyTitle>
            <PolicyText>
              当サイトでは、第三者配信の広告サービスである「グーグルアドセンス」を利用し、第三者配信事業者や広告ネットワークの配信する広告が掲載されます。この広告サービスでは、上述のCookieを利用することで、ユーザーが当サイトに訪れた情報や過去他のサイトに訪れた情報に基づき、適切な広告を表示します。
            </PolicyText>
            <PolicyTitle>免責事項</PolicyTitle>
              当サイトのコンテンツ・情報につきまして、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。<br />
              当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。
              <PolicyLink href="https://yuis-webmemo.org/contact/" target="_blank">お問い合わせはこちらから</PolicyLink>
            <PolicyText> 
            </PolicyText>
          </Card>
        </MainContent>
        <Footer>
          <MainContent>
            <div style={{ marginBottom: '20px', fontSize: '14px' }}>
              <Link to='/' style={{ marginRight: '12px'}}>トップ</Link> 
              <Link to='/privacy-policy'>プライバシーポリシー</Link> 
            </div>
            <p>© 2018 <a href="https://twitter.com/yu_webmemo" target="_blank" rel="noopener noreferrer">@yu_webmemo</a> & <a href="https://twitter.com/matsu_marketer" target="_blank" rel="noopener noreferrer">@matsu_marketer</a></p>
          </MainContent>
        </Footer>
      </div>
    );
  }
}

export default PrivacyScreen;



// WEBPACK FOOTER //
// ./src/PrivacyScreen.js